const GUEST_SHORTLIST_COMPANY_IDS_KEY = "gt_guest_shortlist_company_ids";
const GUEST_SHORTLIST_ECOSYSTEM_HEAD_USER_IDS_KEY = "gt_guest_shortlist_ecosystem_head_user_ids";
const GUEST_SHORTLIST_EXPERT_USER_IDS_KEY = "gt_guest_shortlist_expert_user_ids";

function normalizeIds(ids: unknown): string[] {
  if (!Array.isArray(ids)) return [];
  const unique = new Set<string>();
  ids.forEach((id) => {
    if (typeof id !== "string") return;
    const trimmed = id.trim();
    if (!trimmed) return;
    unique.add(trimmed);
  });
  return Array.from(unique);
}

function readIds(key: string): string[] {
  const raw = localStorage.getItem(key);
  if (!raw) return [];
  try {
    return normalizeIds(JSON.parse(raw));
  } catch {
    return [];
  }
}

function saveIds(key: string, ids: string[]) {
  const normalized = normalizeIds(ids);
  localStorage.setItem(key, JSON.stringify(normalized));
}

function addId(key: string, id: string): string[] {
  const current = readIds(key);
  const trimmed = id.trim();
  if (!trimmed || current.includes(trimmed)) return current;
  const next = [...current, trimmed];
  saveIds(key, next);
  return next;
}

function removeIds(key: string, idsToRemove: string[]): string[] {
  if (idsToRemove.length === 0) return readIds(key);
  const removeSet = new Set(idsToRemove.map((id) => id.trim()).filter(Boolean));
  const next = readIds(key).filter((id) => !removeSet.has(id));
  saveIds(key, next);
  return next;
}

export function readGuestShortlistCompanyIds(): string[] {
  return readIds(GUEST_SHORTLIST_COMPANY_IDS_KEY);
}

export function saveGuestShortlistCompanyIds(companyIds: string[]) {
  saveIds(GUEST_SHORTLIST_COMPANY_IDS_KEY, companyIds);
}

export function addGuestShortlistCompanyId(companyId: string) {
  return addId(GUEST_SHORTLIST_COMPANY_IDS_KEY, companyId);
}

export function removeGuestShortlistCompanyIds(companyIdsToRemove: string[]) {
  return removeIds(GUEST_SHORTLIST_COMPANY_IDS_KEY, companyIdsToRemove);
}

export function removeGuestShortlistCompanyId(companyId: string) {
  return removeGuestShortlistCompanyIds([companyId]);
}

export function readGuestShortlistEcosystemHeadUserIds(): string[] {
  return readIds(GUEST_SHORTLIST_ECOSYSTEM_HEAD_USER_IDS_KEY);
}

export function addGuestShortlistEcosystemHeadUserId(ecosystemHeadUserId: string) {
  return addId(GUEST_SHORTLIST_ECOSYSTEM_HEAD_USER_IDS_KEY, ecosystemHeadUserId);
}

export function removeGuestShortlistEcosystemHeadUserIds(idsToRemove: string[]) {
  return removeIds(GUEST_SHORTLIST_ECOSYSTEM_HEAD_USER_IDS_KEY, idsToRemove);
}

export function readGuestShortlistExpertUserIds(): string[] {
  return readIds(GUEST_SHORTLIST_EXPERT_USER_IDS_KEY);
}

export function addGuestShortlistExpertUserId(expertUserId: string) {
  return addId(GUEST_SHORTLIST_EXPERT_USER_IDS_KEY, expertUserId);
}

export function removeGuestShortlistExpertUserIds(idsToRemove: string[]) {
  return removeIds(GUEST_SHORTLIST_EXPERT_USER_IDS_KEY, idsToRemove);
}
